import { configureStore } from '@reduxjs/toolkit';
//import {thunk} from 'redux-thunk';
import {thunk} from 'redux-thunk';
import {createLogger} from 'redux-logger';
import { subscriptionReducer } from './reducers/subscription-reducer';
import { userReducer } from './reducers/user-reducer';
import { settingReducer } from './reducers/setting-reducer';
import { paymentReducer } from './reducers/payment-reducer';
//import { facebookReducer } from './reducers/facebook-reducer';


const loggerMiddleware = createLogger();

export const store = configureStore({
  reducer : {subscriptionReducer, userReducer, settingReducer, paymentReducer},
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(
        // correctly typed middlewares can just be used
        [loggerMiddleware],
      )
      // prepend and concat calls can be chained
      //.concat(loggerMiddleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;